<template>
  <section
    v-editable="blok"
    :class="blok.isHScreen ? 'h-screen' : 'h-default'"
    class="offices-list theme-light"
  >
    <div class="container">
      <div v-if="blok.title" class="offices-list__filter">{{ blok.title }}</div>
      <ul v-if="offices.length" class="row offices-list__list">
        <component
          :is="'m-office-card' | dashify"
          v-for="office in offices"
          :key="office.id"
          :item="office"
        />
      </ul>

      <div v-if="!offices.length" class="row offices-list__empty">
        <div class="col-12">Sorry, there are no results.</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OfficesList',
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
    datas: {
      type: Array,
      default: () => [],
    },
    requestData: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      offices: [],
    }
  },
  watch: {
    datas(newValue) {
      this.offices = []
      for (let i = 0; i < newValue.length; i += 1) {
        this.offices.push(newValue[i].content.card[0])
      }
    },
  },
  mounted() {
    if (this.requestData) {
      this.$storyapi
        .get('cdn/stories', {
          starts_with: (this.blok || {}).api || 'offices/',
          is_startpage: '0',
          cv: this.$store.state.cacheVersion,
          version: 'published',
        })
        .then((res) => {
          for (let i = 0; i < res.data.stories.length; i += 1) {
            this.offices.push(res.data.stories[i].content.card[0])
          }
        })
        .catch((res) => {
          // eslint-disable-next-line no-console
          console.error('Office List - Failed to load resource', res)
        })
    }
  },
}
</script>

<style lang="scss">
@import '../../../assets/scss/settings';

.offices-list {
  padding: spacer(3) 0;

  &__filter {
    @include font-size(12);

    margin: 0;
    padding: spacer(2) 0;
  }

  &__list {
    display: flex;
    padding: spacer(1) 0 spacer(1);
    margin: 0;
    list-style: none;
  }
}

@include media-breakpoint-up(lg) {
  .offices-list__empty {
    padding: spacer(3) 0;
  }
}
</style>
